//  style ===>>> layouts/default.scss

<template>

	<!-- Layout Header ( Navbar ) -->
	<a-layout-header>
		<div class="header-col header-brand">
			<img 
				src="/images/logos/logo.svg" 
				class="header-logo"
				@click.prevent="navigateTo('Index')"
				style="cursor: pointer"
			/>
			<!-- <h6 style="color: black !important;">{{ $t('site-title-l1') }}<br> {{ $t('site-title-l2') }}</h6> -->
			<h6 style="color: black !important;">{{ $t('site-title-l1') }} {{ $t('site-title-l2') }}</h6>
		</div>

		<div class="header-col  default_login_btn" v-show="!isSignIn">
            <locale-dropdown class="default_locale" style="margin-right: 10px;"/>
			<a-button class="primary" @click="navigateTo('SignIn')" type="primary" >{{ $t('log-in-btn-caption')}}</a-button>
		</div>

        <div class="header-col default_register_btn" v-show="isSignIn">
            <locale-dropdown class="default_locale" style="margin-right: 10px;"/>
			<a-button class="primary" @click="navigateTo('Apply')" type="primary" >{{ $t("register-btn-caption")}}</a-button>
		</div>

	</a-layout-header>
</template>

<script>
import { navigationMixin } from "../../mixins/navigation-mixin.js";
import LocaleDropdown from '../../locales/LocaleDropdown.vue';
	export default ({
		mixins: [ navigationMixin ], 
		components:{
            LocaleDropdown
		},
		data() {
			return {
				// Collapse navigation value.
				// Binded model property for "Collapsible Navigation Menu" collapsed status .
				collapseNav: 0,
				shouldShowUserInfo: false,
				user:"",
			}
		},
        computed: {
            isSignIn() {
                return this.$route.name == 'SignIn';
            }
        },
		methods:{
			
		}
	})

</script>

<style lang="scss" scoped>
	.profile_dropdown_div{
		position: relative;
		right: 94px;
		top: 5px;
		width:100px;
		height: 60px;
		border: 2px solid #e5e5e5;
		border-radius: 30px;
		padding: 0px 4px 1px 17px;
		cursor: pointer;
		background-color:#fff; 
	}
	.nav-link svg {
		margin-right: 5px;
		vertical-align: middle;
	}
	.nav-link span {
		vertical-align: middle;
	}
	.ant-menu-submenu-popup {
		width: 100%;
	}

</style>